import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import s from './SeoTexts.css';

class SeoTexts extends React.Component {
  static propTypes = {
    isMobile: PropTypes.bool,
    seoText: PropTypes.string,
    currentPath: PropTypes.string,
  };
  static defaultProps = {
    seoText: '',
    currentPath: '',
    list: null,
    onClick: undefined,
    isMobile: false,
  };
  state = {
    collapsed: false,
  };

  componentDidMount() {
    setTimeout(() => this.setState({ collapsed: true }), 1);
  }

  componentWillUpdate(nextProps) {
    if (nextProps.currentPath !== this.props.currentPath && this.state.collapsed) {
      // eslint-disable-next-line react/no-will-update-set-state
      this.setState({ collapsed: true });
    }
  }
  toggleCollapse = () => {
    this.setState(({ collapsed }) => ({ collapsed: !collapsed }));
  };
  createMarkup = () => ({ __html: this.props.seoText });
  render() {
    const { isMobile, seoText } = this.props;
    const { collapsed } = this.state;

    if (!seoText) return '';

    return (
      <div className={cx(s.root, { [s.mobile]: isMobile })}>
        <div
          className={cx(s.toggleArea, { [s.toggleAreaActive]: !collapsed })}
          onClick={this.toggleCollapse}
        >
          &nbsp;
        </div>
        <div className={cx(s.title, { [s.active]: !collapsed })}>
          <div>
            <div
              dangerouslySetInnerHTML={this.createMarkup()}
              className={cx(s.textStyle, { [s.closeSeo]: collapsed })}
            />
          </div>
          <i className={`fa fa-angle-down ${s.titleIcon}`} />
        </div>
      </div>
    );
  }
}

export default withStyles(s)(
  connect(({ globals }) => ({ seoText: globals.seoText && globals.seoText.seoTextData }))(SeoTexts),
);



// WEBPACK FOOTER //
// ./src/shared/components/SeoTexts/SeoTexts.js